var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShifts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m496.7 0.365h-481.4c-8.45 0-15.301 6.851-15.301 15.301v480.67c0 8.45 6.851 15.301 15.301 15.301h481.4c8.45 0 15.301-6.851 15.301-15.301v-480.67c0-8.45-6.851-15.301-15.301-15.301zm-15.301 480.67h-450.8v-450.06h450.8v450.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m225.01 123.02h-119.34c-8.45 0-15.301 6.851-15.301 15.301s6.851 15.301 15.301 15.301h119.34c8.45 0 15.301-6.851 15.301-15.301 1e-3 -8.45-6.85-15.301-15.301-15.301z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m225.01 244.56h-119.34c-8.45 0-15.301 6.851-15.301 15.301s6.851 15.301 15.301 15.301h119.34c8.45 0 15.301-6.851 15.301-15.301 1e-3 -8.45-6.85-15.301-15.301-15.301z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m225.01 366.1h-119.34c-8.45 0-15.301 6.851-15.301 15.301s6.851 15.301 15.301 15.301h119.34c8.45 0 15.301-6.851 15.301-15.301 1e-3 -8.45-6.85-15.301-15.301-15.301z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m427.71 91.782c-5.769-6.175-15.451-6.503-21.627-0.733l-60.053 56.116-19.858-19.298c-6.06-5.889-15.748-5.752-21.637 0.309-5.89 6.06-5.751 15.748 0.309 21.637l30.315 29.461c2.966 2.883 6.814 4.328 10.665 4.328 3.75 0 7.503-1.372 10.446-4.121l70.707-66.072c6.174-5.77 6.502-15.453 0.733-21.627z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m427.71 213.32c-5.77-6.176-15.452-6.502-21.627-0.733l-60.053 56.116-19.858-19.298c-6.06-5.89-15.748-5.753-21.637 0.309-5.89 6.06-5.751 15.748 0.309 21.637l30.315 29.461c2.966 2.883 6.814 4.328 10.665 4.328 3.75 0 7.503-1.372 10.446-4.121l70.707-66.072c6.174-5.769 6.502-15.452 0.733-21.627z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m427.71 334.86c-5.77-6.176-15.452-6.502-21.627-0.733l-60.053 56.116-19.858-19.298c-6.06-5.89-15.748-5.752-21.637 0.309-5.89 6.06-5.751 15.748 0.309 21.637l30.315 29.461c2.966 2.883 6.814 4.328 10.665 4.328 3.75 0 7.503-1.372 10.446-4.121l70.707-66.072c6.174-5.77 6.502-15.452 0.733-21.627z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShifts);
export default __webpack_public_path__ + "static/media/shifts.11e5be97609b204eed2015a542512656.svg";
export { ForwardRef as ReactComponent };